import { ThunkAction } from "redux-thunk";
import { IExtra, RootAction, RootState } from "../types";

import { logIn as logInAction } from "../actions/loginActions";

export function logIn(
  username: string,
  password: string
): ThunkAction<void, RootState, IExtra, RootAction> {
  return async (dispatch, _, { firebase }) => {
    try {
      dispatch(logInAction.request());

      if (!firebase.auth) {
        throw new Error("firebase auth not initialized");
      }
      await firebase.auth().signInWithEmailAndPassword(username, password);

      dispatch(logInAction.success());
    } catch (err) {
      dispatch(logInAction.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/loginThunks.ts